const t = {
  name: "MinusMultiple",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 13H18V15H10V13Z" fill="currentColor"/>
<path d="M2 5C2 3.34315 3.34315 2 5 2H15C16.6569 2 18 3.34315 18 5V6H19C20.6569 6 22 7.34315 22 9V19C22 20.6569 20.6569 22 19 22H9C7.34315 22 6 20.6569 6 19V18H5C3.34315 18 2 16.6569 2 15V5ZM8 19C8 19.5523 8.44772 20 9 20H19C19.5523 20 20 19.5523 20 19V9C20 8.44772 19.5523 8 19 8H9C8.44772 8 8 8.44772 8 9V19ZM16 6V5C16 4.44772 15.5523 4 15 4H5C4.44772 4 4 4.44772 4 5V15C4 15.5523 4.44772 16 5 16H6V9C6 7.34315 7.34315 6 9 6H16Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as MinusMultiple
};
